import { z } from 'zod';
import type { TaskType } from 'packages/lib/api/annotations/contract/enums';

// 2026-08-04 Used Cursor (Opus 5) for initial design

/** Value of the `type` query param, which drives the Cost/Throughput/Quality tabs. */
export const analyticsTypeURLParamZod = z.enum([
  'cost',
  'throughput',
  'quality',
]);
export type AnalyticsType = z.infer<typeof analyticsTypeURLParamZod>;

/**
 * The Contributors menu is a two-way switch over the `managerEmail` filter. Values
 * double as the `contributors` query param.
 */
export const contributorScopeZod = z.enum(['all', 'directReports']);
export type ContributorScope = z.infer<typeof contributorScopeZod>;

/**
 * Aggregated in the client. The endpoint returns one row per child group, and every
 * summary figure is a sum or average over those rows.
 */
export interface CostSummary {
  costPerTask: number;
  /** Null when no row has a frame dimension. */
  costPerFrame: number | null;
  /** Null when no row has an annotation dimension. */
  costPerAnnotation: number | null;
  labelingTotal: number;
  industryTotal: number;
  /** Industry total expressed as a multiple of the labeling total. */
  industryRatio: number;
  qaTotal: number;
  auditingTotal: number;
  totalCost: number;
  /** Distinct task types from every table row's includedTaskTypes. */
  includedTaskTypes: TaskType[];
}
